import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

const ReportService = {
  get: (report) =>
    axios
      .get(`${endpoints.BASE_URL}${endpoints.GET_REPORTS}${report}`)
      .then((res) => res.data)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err.message);
      }),

  post: (report, data) =>
    axios
      .post(`${endpoints.BASE_URL}${endpoints.GET_REPORTS}${report}`, data)
      .then((res) => res.data)
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err.message);
      })
};

export default ReportService;
